export enum EdgeType {
  ExplicitDependency = "explicit_dependency",
  ImplicitDependency = "implicit_dependency",
}
